import { getCode } from '@fluentui/accessibility';
var isKeyModifiersMatch = function isKeyModifiersMatch(modifierValue, combinationValue) {
  if (combinationValue === undefined) {
    return true;
  }
  return modifierValue === combinationValue;
};
export var shouldHandleOnKeys = function shouldHandleOnKeys(event, keysCombinations) {
  return keysCombinations.some(function (keysCombination) {
    return keysCombination.keyCode === getCode(event) && isKeyModifiersMatch(event.altKey, keysCombination.altKey) && isKeyModifiersMatch(event.shiftKey, keysCombination.shiftKey) && isKeyModifiersMatch(event.metaKey, keysCombination.metaKey) && isKeyModifiersMatch(event.ctrlKey, keysCombination.ctrlKey);
  });
};
//# sourceMappingURL=shouldHandleOnKeys.js.map
